import React from 'react';

import { ErrorMessage } from '@atlaskit/form';

import { JiraPermissions, ProjectSelectOption } from '@qality/common-model';

import PermissionService from './PermissionService';

const DESCRIPTION_SIZE = 10000;
const NAME_SIZE = 255;
const NOT_FOUND_STATUS = 404;

export type Errors = {
  description?: React.ReactNode;
  name?: React.ReactNode;
  project?: React.ReactNode;
  version?: React.ReactNode;
  dueDate?: React.ReactNode;
};

export default {
  validateName(name: string, errors: Errors): Errors {
    if (!name) {
      errors.name = <ErrorMessage>Name is required.</ErrorMessage>;
      return errors;
    } else if (name.length > NAME_SIZE) {
      errors.name = (
        <ErrorMessage>Name is too long. Max size is 255.</ErrorMessage>
      );
      return errors;
    } else {
      delete errors.name;
      return errors;
    }
  },

  async validateProject(
    project: ProjectSelectOption,
    errors: Errors
  ): Promise<Errors> {
    if (!project) {
      errors.project = <ErrorMessage>Project is required</ErrorMessage>;
      return errors;
    } else {
      let permissions = {} as JiraPermissions;
      try {
        permissions = await PermissionService.hasProjectPermissions(
          project.value,
          ['CREATE_ISSUES']
        );
      } catch (e) {
        if (e.xhr.status === NOT_FOUND_STATUS) {
          errors.project = (
            <ErrorMessage>
              You do not have access to create issues in this project.
            </ErrorMessage>
          );
          return errors;
        }
      }

      if (permissions.CREATE_ISSUES) {
        delete errors.project;
        return errors;
      } else {
        errors.project = (
          <ErrorMessage>
            You do not have access to create issues in this project.
          </ErrorMessage>
        );
        return errors;
      }
    }
  },

  validateDescription(validationDescription: string, errors: Errors): Errors {
    const { description: _description, ...errorsObject } = errors;

    if (validationDescription.length > DESCRIPTION_SIZE) {
      errorsObject.description = (
        <ErrorMessage>Description is too long. Max size is 10000.</ErrorMessage>
      );
    }

    return errorsObject;
  },
};
